/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import addSettingActions, {
    addSettingTypes,
} from '../../../redux/settings/addSetting'
import getSettingActions from '../../../redux/settings/getSetting'
import { Post } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* addSettingSagas({ response }) {
    try {
        const res = yield Post('delais/', response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(addSettingActions.addSettingSuccess(res.data)),
                yield put(getSettingActions.getSettingRequest()),
            ])
            if (res.data) {
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: null,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                )
            }
        } else {
            yield put(addSettingActions.addSettingFailure(res))
        }
    } catch (error) {
        yield put(addSettingActions.addSettingFailure(error))
    }
}

export function* addSettingSaga() {
    yield takeLatest(addSettingTypes.ADD_SETTING_REQUEST, addSettingSagas)
}
